import type { FC } from "react";
import React from "react";
import classnames from "classnames";

import { hasWindow } from "@litres/utils";
import { useTranslation } from "@litres-libs/i18n";

import { useApi } from "../../../hooks/useApi";

import styles from "./SearchHistory.module.scss";

import type { ISearchHistoryProps } from "../types";

export const SearchHistory: FC<ISearchHistoryProps> = ({
  history,
  setHistoryRefreshed,
  searchHistoryListRef,
  setLoading,
  isDesktop = true,
  onClose,
}) => {
  const { t } = useTranslation();
  const { clearSearchHistory } = useApi();
  const reversedHistory = history.slice(0, 10).reverse();

  const handleClearHistoryClick = (): void => {
    clearSearchHistory();
    setHistoryRefreshed(true);
  };

  const handleHistoryItemClick = (value: string): void => {
    setLoading(true);

    if (hasWindow) {
      window.location.assign(`/search/?q=${encodeURIComponent(value)}`);
    }
  };

  return (
    <ul
      className={classnames(styles.list, { [styles.mobileList]: !isDesktop })}
      ref={searchHistoryListRef}
      data-testid="header__search-history"
    >
      <div className={styles.info}>
        <p className={styles.previousSearches}>{t("Ранее вы искали")}</p>

        <p className={styles.clear} onClick={handleClearHistoryClick}>
          {isDesktop ? t("Очистить историю") : t("Очистить")}
        </p>
      </div>

      {reversedHistory.map(({ value }) => (
        <li
          className={styles.item}
          key={value}
          tabIndex={0}
          onClick={(): void => {
            handleHistoryItemClick(value);
          }}
        >
          {value}
        </li>
      ))}

      {!isDesktop && (
        <li className={styles.close} tabIndex={0} onClick={onClose}>
          {t("Закрыть")}
        </li>
      )}
    </ul>
  );
};

export default SearchHistory;
